import { render, staticRenderFns } from "./TeacherList.vue?vue&type=template&id=78f3a599&scoped=true&"
import script from "./TeacherList.vue?vue&type=script&lang=js&"
export * from "./TeacherList.vue?vue&type=script&lang=js&"
import style0 from "./TeacherList.vue?vue&type=style&index=0&id=78f3a599&lang=scss&scoped=true&"
import style1 from "./TeacherList.vue?vue&type=style&index=1&id=78f3a599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f3a599",
  null
  
)

/* custom blocks */
import block0 from "./TeacherList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports